export default __webpack_public_path__ + "static/icon-features-2-fd910b144002050479379d6f1e286058.png";